"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.PoiCategoryDualList = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _commonDualList = _interopRequireDefault(require("./common-dual-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getPoiCategories = function getPoiCategories(state) {
  return state.informationLists.poiCategories;
};

var poiCategorySelector = (0, _reselect.createSelector)(getPoiCategories, function (categories) {
  return categories.map(function (_ref) {
    var id = _ref.id,
        name = _ref.name;
    return {
      id: id,
      label: name
    };
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    poiCategories: poiCategorySelector(state)
  };
};

exports.mapStateToProps = mapStateToProps;

var PoiCategoryDualList = function PoiCategoryDualList(_ref2) {
  var poiCategories = _ref2.poiCategories,
      selectedPoiCategories = _ref2.selectedPoiCategories,
      allPoiCategoriesSelected = _ref2.allPoiCategoriesSelected,
      _onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithText, null),
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "duallist.poiCategories",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_commonDualList["default"], {
    items: poiCategories,
    allItemsSelected: allPoiCategoriesSelected,
    selectedItems: selectedPoiCategories,
    onChange: function onChange(_ref3) {
      var allItemsSelected = _ref3.allItemsSelected,
          selectedItems = _ref3.selectedItems;
      return _onChange({
        allPoiCategoriesSelected: allItemsSelected,
        selectedPoiCategories: selectedItems
      });
    }
  }));
};

exports.PoiCategoryDualList = PoiCategoryDualList;
PoiCategoryDualList.propTypes = {
  allPoiCategoriesSelected: _propTypes["default"].bool,
  poiCategories: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  selectedPoiCategories: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func
};
PoiCategoryDualList.defaultProps = {
  allPoiCategoriesSelected: true,
  poiCategories: [],
  selectedPoiCategories: [],
  onChange: function onChange() {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PoiCategoryDualList);

exports["default"] = _default;